import { RootState } from "../..";
import { ChartData } from "./types";

export const selectChartData = (state: RootState): ChartData[] => state.public.chart.chartDatas;
